import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'

const firebaseConfig = {
    apiKey: "AIzaSyC6HL6baD4TQlkW6nk-YO21zjoXYt5_zHA",
    authDomain: "resolver-app-20.firebaseapp.com",
    databaseURL: "https://resolver-app-20.firebaseio.com",
    projectId: "resolver-app-20",
    storageBucket: "resolver-app-20.appspot.com",
    messagingSenderId: "195368633202",
    appId: "1:195368633202:web:baac0f68121768a54f53eb",
    measurementId: "G-CPYRSPHMDE"
}
firebase.initializeApp(firebaseConfig)

export const firebaseDB = firebase.firestore()
export const firebaseAuth = firebase.auth()
export const firebaseStorage = firebase.storage()
export const TaskState = firebase.storage.TaskState